import Image from "mui-image";

/**
 * Renders an icon polymorphically — string path → Image, JSX → raw element.
 * Used by both Header and Sidebar button components.
 */
const IconRenderer = ({ icon, text, size = "25px" }) => (
	typeof icon === "string"
		? <Image src={icon} alt={text} fit="contain" width={size} />
		: <span style={{ fontSize: size, display: "flex", alignItems: "center", color: "white" }}>{icon}</span>
);

export default IconRenderer;
